'use client'

import { trackCTAClick, trackTrialStart } from '@/lib/analytics'

const basic = {
  name: 'Basic',
  desc: 'Essential features to get started.',
  price: '$0',
  unit: 'forever free',
  meta: 'no card required',
  features: [
    '50 AI credits (one-time)',
    '10 hours recording/month',
    'Up to 10 AI tasks',
    '1 calendar (Google/Outlook/iOS)',
    'Up to 5 projects',
    'Unlimited tasks, appointments & notes',
    'Chat with AVA on WhatsApp',
    'Cross-platform sync',
  ],
  cta: 'Try AVA Free',
}

const pro = {
  name: 'Pro',
  tag: 'Most Popular',
  desc: 'Unlimited productivity power. Best for daily power users and professionals.',
  priceItalic: '$0.33',
  unit: '/day',
  meta: '$9.99/month or $99/year (save 17%)',
  features: [
    '2,000 AI credits/month',
    '100 hours recording/month',
    'Unlimited AI tasks',
    '5 calendars (all synced)',
    'Unlimited projects',
    { heading: true, text: 'Everything in Basic, plus:' },
    'Zero Inbox — AI-powered email triage',
    'Priority support & early feature access',
  ],
  cta: 'Start Free Trial',
}

export default function Pricing({ platformLink = '/login?mode=signup', isMobile = false }) {
  const target = isMobile ? '_blank' : undefined
  const rel = isMobile ? 'noopener noreferrer' : undefined
  return (
    <div>
      <div className="pricing-grid">
        <Plan plan={basic} platformLink={platformLink} target={target} rel={rel} location="pricing_basic" />
        <Plan plan={pro} dark platformLink={platformLink} target={target} rel={rel} location="pricing_pro" />
      </div>

      <div className="best-value-band">
        <div className="key">Best value</div>
        <p>
          <strong>One subscription that replaces 10+ apps</strong> — tasks, notes,
          calendar, meetings, and more.
        </p>
        <p>
          Save over $100/month with AVA&rsquo;s all-in-one plan for just <strong>$10</strong>.
        </p>
      </div>
    </div>
  )
}

function Plan({ plan, dark = false, platformLink, target, rel, location }) {
  return (
    <div className={'plan' + (dark ? ' dark' : '')}>
      <div className="plan-head">
        <div className="plan-name">{plan.name}</div>
        {plan.tag && <span className="plan-tag">{plan.tag}</span>}
      </div>
      <p className="plan-desc">{plan.desc}</p>

      <div style={{ position: 'relative', zIndex: 2 }}>
        <div className="plan-price">
          {plan.priceItalic ? <em>{plan.priceItalic}</em> : plan.price}
          <span className="unit">{plan.unit}</span>
        </div>
        <div className="plan-price-meta">{plan.meta}</div>
      </div>

      <ul className="plan-features">
        {plan.features.map((f, i) =>
          typeof f === 'object' && f.heading ? (
            <li key={i} className="heading">{f.text}</li>
          ) : (
            <li key={i}>
              <span className="check">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12l5 5 9-11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              {f}
            </li>
          )
        )}
      </ul>

      <div className="plan-cta-row">
        <a
          href={platformLink}
          target={target}
          rel={rel}
          className={'btn ' + (dark ? 'btn-primary' : 'btn-secondary')}
          onClick={() => {
            trackCTAClick(plan.cta, location)
            trackTrialStart(location)
          }}
        >
          {plan.cta}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      </div>
    </div>
  )
}
